/* eslint-disable canonical/filename-match-exported -- FIXME: Fix this ESLint violation! */
import { makeAutoObservable } from 'mobx'

import type Service from '.'
import type { AcceptedReferral, ReferralCode } from './model'

export default class ReferralStore {
  private _referralCodes: ReferralCode[] = []
  private _acceptedReferrals: AcceptedReferral[] = []

  constructor(private root: Service) {
    makeAutoObservable(this, {})
  }

  get referralCode(): string | null {
    if (this._referralCodes.length === 0) {
      return null
    }

    return this._referralCodes[this._referralCodes.length - 1]?.code ?? null
  }

  set referralCodes(codes: ReferralCode[]) {
    this._referralCodes = codes
  }

  get acceptedReferrals() {
    return this._acceptedReferrals
  }

  set acceptedReferrals(accepted: AcceptedReferral[]) {
    this._acceptedReferrals = accepted
  }

  fetchCodes() {
    return this.root.transport.account.referrals.getCode().then((codes) => {
      this.referralCodes = codes
      return codes
    })
  }

  fetchAccepted() {
    return this.root.transport.account.referrals
      .getAcceptedReferrals()
      .then((accepted) => {
        if (accepted !== this.acceptedReferrals) {
          this.acceptedReferrals = accepted
        }
        return accepted
      })
  }

  accept(code: string) {
    return this.root.transport.account.referrals.accept(code)
  }
}
